module.exports = __webpack_public_path__ + "static/img/new-16.b6058a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-16.png
// module id = 7hWI
// module chunks = 0